module.exports = __webpack_public_path__ + "img/delete.f632f136.svg";